import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';

/** Phone widths, where `textOnlyOnPhone` takes effect. Matches the md breakpoint. */
const PHONE_MEDIA_QUERY = '(max-width: 767.98px)';

@Component({
    selector: 'rms-no-content',
    templateUrl: './no-content.component.html',
    styleUrls: ['./no-content.component.scss'],
    standalone: false
})

export class NoContentComponent implements OnInit, OnDestroy {
  /** When true, the message indicates active filters are hiding results, rather than no data existing. */
  @Input() filtersActive = false;
  /**
   * When true, applies the compact filter-pane polish (lighter font weight, narrower vertical
   * padding, centered text). Opt-in so the 30+ existing consumers keep their original styling.
   */
  @Input() compact = false;
  /**
   * When true, phone widths get a text-only state: no illustration, 12px copy, the short
   * filtered-out message, the Clear Filters link on its own line, and the content pinned to the
   * visible width so the link stays on screen in a table wider than the phone. Opt-in, and read
   * once on init.
   */
  @Input() textOnlyOnPhone = false;
  /**
   * Emitted when the user clicks the inline "Clear Filters" link rendered in compact mode
   * with active filters. Hosts wire this to their filter-reset handler.
   */
  @Output() clearFilters = new EventEmitter<void>();

  public isPhone = false;

  private breakpointSubscription: Subscription;

  constructor(private readonly breakpointObserver: BreakpointObserver) { }

  /** The translation key for the current state, width and opt-in. */
  get messageKey(): string {
    if (!this.filtersActive) {
      return 'TABLES.NO_CONTENT';
    }
    return this.textOnlyOnPhone && this.isPhone ? 'TABLES.NO_CONTENT_FILTERS_SHORT' : 'TABLES.NO_CONTENT_FILTERS';
  }

  ngOnInit(): void {
    if (this.textOnlyOnPhone) {
      this.breakpointSubscription = this.breakpointObserver.observe(PHONE_MEDIA_QUERY)
        .subscribe(state => this.isPhone = state.matches);
    }
  }

  ngOnDestroy(): void {
    this.breakpointSubscription?.unsubscribe();
  }

  public onClearFiltersClick(): void {
    this.clearFilters.emit();
  }
}
